import { render, staticRenderFns } from "./caseRecords.vue?vue&type=template&id=6b80e12a&scoped=true&"
import script from "./caseRecords.vue?vue&type=script&lang=js&"
export * from "./caseRecords.vue?vue&type=script&lang=js&"
import style0 from "./caseRecords.vue?vue&type=style&index=0&id=6b80e12a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b80e12a",
  null
  
)

export default component.exports